import React, { useEffect, useState } from 'react';
import { serviceTagType } from '../../interfaces/serviceTag';
import ServiceTag from '../ServiceTag/ServiceTag';
import useComponentsStore from '../../store/componentsStateStore';

const ServiceTagContainer = ({ items }: { items: serviceTagType[] }) => {
    const [selectedTag, setSelectedTag] = useState<number | null>(null);
    const [isMobile, setIsMobile] = useState(false);
    const [loadingTags, setLoadingTags] = useState<{ [key: number]: boolean }>({});

    const {
        continueDraft,
    } = useComponentsStore();

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            const isMobileDevice = screenWidth <= 572;
            setIsMobile(isMobileDevice);
        };

        // Attach the resize event listener
        window.addEventListener("resize", handleResize);

        // Check initial screen width on component mount
        handleResize();

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleTagClick = async (index: number, data: serviceTagType) => {
        try {
            setSelectedTag(index);

            // Set the loading state of the clicked tag to true
            setLoadingTags(prev => ({ ...prev, [index]: true }));

            await continueDraft(data.actionClick.payload);
        } catch (err) {
            console.error(err);
        } finally {
            // Set the loading state of the clicked tag to false
            setLoadingTags(prev => ({ ...prev, [index]: false }));
        }
    };

    return (
        <div className={`vas-w-100 vas-mt-3 vas-mb-3 ${!isMobile ? "vas-px-4" : "vas-px-2"} vas-d-flex vas-gap-3`}>
            {items &&
                items.length > 0 &&
                items.map((item, idx) => (
                    <ServiceTag
                        loading={loadingTags[idx] || false} // Pass the loading state for the specific tag
                        isSelected={selectedTag === idx}
                        data={item}
                        key={idx}
                        onClick={() => handleTagClick(idx, item)}
                    />
                ))}
        </div>
    );
};

export default ServiceTagContainer;
